<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">服务</div></div>
                <div class="title">测试</div>
                <div class="minTitle">各个测试领域的经验积累，建立了完善的测试规范及质量保障体系，测试团队拥有专业素质、丰富的测试技能，且在保险、金融行业综合测试能力尤为突出。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
        <picture>
            <source srcset="@/assets/images/fu1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/fu1.png" />
        </picture>

       <div class="lxwm tt">
            <div class="title1 tc">我们的测试产品</div>
            <div class="content">
                <div class="items mt15">
                    <div class="item">
                        <img src="@/assets/images/fu2.png" />
                        <div class="lb">
                            用户验收（UAT）测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu3.png" />
                        <div class="lb">
                            QA活动
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu4.png" />
                        <div class="lb">
                            质量保证制度和测试规范体系建设
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu5.png" />
                        <div class="lb">
                            单元测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu6.png" />
                        <div class="lb">
                            系统集成测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu7.png" />
                        <div class="lb">
                            系统功能测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu8.png" />
                        <div class="lb">
                            软件性能测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu9.png" />
                        <div class="lb">
                            安装部署测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu10.png" />
                        <div class="lb">
                            自动化测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu11.png" />
                        <div class="lb">
                            现场测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu12.png" />
                        <div class="lb">
                            离岸测试
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/images/fu13.png" />
                        <div class="lb">
                            高端技术外派
                        </div>
                    </div>
                </div>
            </div>
       </div>

       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">保险行业案例</div>
                <div class="items mt15">
                    <div class="item2">
                        <div class="flex">
                            <img src="@/assets/images/fu14.png" />
                            <div class="lb">
                                理赔
                            </div>
                        </div>
                        <div class="minTitle2">
                            理赔平台作为保险业务的核心系统，从以客户为中心、多渠道融合、流程自动化、管理智能化及完善的风险防控几个方面，为保险公司提供从报案、立案、初审、理算、复核、结案等理赔业务流程的系统服务。平台对接保险公司官网、移动APP、微信、机器人，支持自动理赔、异地理赔、快赔、闪赔及绿色通道；通过规则引擎实现任务分配及账单理算的自动化；提供大量辅助功能方便理赔作业人员完成日常工作；提供完善的审计及日志跟踪功能。
                        </div>
                    </div>
                    <div class="item2 transparent">
                        <div class="flex">
                            <img src="@/assets/images/fu15.png" />
                            <div class="lb">
                                续保
                            </div>
                        </div>
                        <div class="minTitle2">
                            车险续保管系统围绕“优质客户续保率”这一关键指标，以灵活的续保任务分配机制和续保名单管理功能未核心，包含业务选择、过程管理、客户价值评估、客户信息补充与收集等功能，为分公司续保团队打造销售管理“利器”。<br/>实现续保任务的统一管理、分配、跟进、和统计。来提升续保率，提高公司盈利。
                        </div>
                    </div>
                    <div class="item2 item3">
                        <div class="flex">
                            <img src="@/assets/images/fu16.png" />
                            <div class="lb">
                                数据中台
                            </div>
                        </div>
                       
                        <div class="minTitle2">
                            基于业务规则，定义统一的接口标准形式，对内外部系统开放统一。<br/>营销移动应用服务中台是承接太保前端系统调、业务微服务接入、互联网业务接入、产险2016版银保销售管理系统的作用，该项目包含基础服务的接口认证、配置管理中心、注册中心服务等以及业务服务的客户服务、活动产品方案服务、新投保服务等功能，该系统是无前端页面，纯接口调用架构。
                        </div>
                    </div>
                    <div class="item2 transparent">
                        <div class="flex">
                            <img src="@/assets/images/fu17.png" />
                            <div class="lb">
                                绩效系统
                            </div>
                        </div>
                        
                        <div class="minTitle2">
                            保险销售绩效考核，采集并统计业务报表，对保险人员进行绩效管理产险2017版销售团队绩效管理系统是电销坐席人员的线上化管理；具体功能包括组织架构管理、智慧招聘、培训智达、高效人管、科学考评、数字算薪、资产管理、系统及基础数据管理等团队绩效模块用于交叉、车商、电销、团车、个代五大渠道人员绩效管理；具体功能包括岗位编制、人员团队、绩效考核、薪酬管理、分析报表、权限管理等
                        </div>
                    </div>
                    <div class="item2">
                        <div class="flex">
                            <img src="@/assets/images/fu18.png" />
                            <div class="lb">
                                人工智能
                            </div>
                        </div>
                        
                        <div class="minTitle2">
                            利用语音情绪识别技术在车险反欺诈领域打造的一款人工智能产品“听风者”是公司利用语音情绪识别技术在车险反欺诈领域打造的一款人工智能产品。通过在车险报案环节嵌入语音情绪识别，将客户报案的“喜、怒、哀、乐、沉、惊、恐、厌”7种情绪特征与“疑似酒驾顶包、疑似逃逸和先出险后投保”等车险欺诈场景进行匹配建模，测算欺诈指数，并将疑点类型、现场调查建议第一时间推送给理赔前端的查勘员，实现风控前置。
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bg1 {
            background-color: #F5F7FA;
        }
        .lxwm {
            padding: 30px 0;
            .items {
                display: flex;
                flex-wrap: wrap;
                .item {
                    margin-top: 10px;
                    width: 10.66%;
                    background-color: #ffffff;
                    padding: 15px 3%;
                    text-align: center;
                    img {
                        height: 35px;
                    }
                    .lb {
                       margin-top: 10px;
                    }
                }

                .item2 {
                    margin-top: 10px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        margin-top: 10px;
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
    .index {
        .flash {
            position: relative;
            padding: 0 50px;
            .gg .title {
                font-size: 24px;
            }
        }
        .flashImg {
            height: 100vh;
        }
    }
}
@media (max-width: 960px) {
    .index {
        .flash {
            .gg {
                .title {
                    font-size: 20px;
                }
                .minTitle {
                    width: 40%;
                    font-size: 13px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
        } 
        .lxwm .items {
            justify-content: space-between;
            .item {
                width: 15%;
                padding: 10px 5px;
            }
            .transparent {
                background-color: transparent;
            }
            .item2 {
                margin-top: 10px;
                width: 100%;
                margin-right: 0;
                padding: 15px;
                
                .lb {
                    line-height: unset;
                }
                img {
                    height: 25px;
                }
                .minTitle2 {
                    margin-top: 20px;
                    font-size: 14px;
                }
            }
            .flex {
                display: flex;
                align-items: center;
            }
        }
    }
   
  }
  @media (max-width: 768px) {
      .index {
          .flash {
              padding: 0 15px;
              .minTitle {
                  width: 50%;
                  font-size: 13px;
              }
              .gg {
                  top: 50px;
                  .title {
                      font-size: 20px;
                  }
                  .button {
                      padding: 6px 15px;
                      margin-top: 20px;
                  }
              }
              
          }
          .flashImg {
              height: 40vh;
          } 
          .tt {
            padding-top: 0;
            .title1 {
                margin: 0;
                padding: 35px 0 30px;
                background-color: #F5F7FA;
            }

          }
          .lxwm .items .item {
            width: 32%;
            margin-top: 0;
            padding: 10px 0;
          }
      }
  }
</style>